import { partial } from '../../../util/translation/translation';

const validateNewsCategory = (values) => {
  const p = partial('validateErrors');
  const errors = {};
  if (!values.name) {
    errors.name = p('nameFieldEmpty');
  }
  return errors;
};

export default validateNewsCategory;
